import clsx from 'clsx';
import styles from '../../styles.module.scss';

export const ImagePlaceholder: React.FC<{ className?: string; aspectRatio?: number }> = ({
  className,
  aspectRatio = 1
}) => (
  <div
    className={clsx(styles.imagePlaceholder, className)}
    style={{
      paddingTop: `${100 / aspectRatio}%`
    }}
  />
);
